// extracted by mini-css-extract-plugin
export default {"input":"PafHiwexBno0LEsareIQ","text":"ssq7NvL1p00VeKNcyPW1"};